import VMasker from 'vanilla-masker/lib/vanilla-masker';
import { telMask, MaskPhone } from '../../../../assets/js/components/maskPhone'
import { BASE_PATH } from '../../../../assets/js/constants';
import axios from 'axios';

const btnAction = document.querySelectorAll('.btn-show-form-leads');
const container = document.querySelector('#container-lightbox-leads-lp-email');
const bg = document.querySelector('#bg-lightbox-leads-lp-email');
const form = document.getElementById('form-leads-lp-email');
const inputTel = container.querySelector('.tel');
const btnSubmit = container.querySelector('.btn-submit');
const btnClose = container.querySelector('.btn-close');
const inputArquivoId = container.querySelector('.input-arquivo');
const textoForm = container.querySelector('.texto-form');
const btnDownloadArquivo = document.querySelector('.btn-link-to-arquivo');

if(inputTel != null){
    VMasker(inputTel).maskPattern(telMask[0]);
    inputTel.addEventListener('input', MaskPhone.bind(undefined, telMask, 14), false);
    inputTel.addEventListener('blur', function(){
        if(this.value.length < 14){
            this.value = '';
        }
    });
}

let LightboxContato = {
    show: function(){
        LightboxContato.init();
        document.body.classList.remove('opened-search-menu', 'opened-menu', 'opened-contato-email');
        document.body.classList.add('opened-leads-lp-email');
    },
    hide: function(){
        document.body.classList.remove('opened-leads-lp-email');
    },
    init: function(){
        container.classList.remove('sucesso', 'erro');
        container.classList.add('init');
        form.classList.remove('validate', 'send');

        form.querySelectorAll('.form-control').forEach(function(elem){
            elem.value = '';
        });
    },
    success: function(){
        container.classList.remove('init', 'erro');
        container.classList.add('sucesso');
    },
    error: function(){
        // container.classList.remove('init', 'sucesso');
        form.classList.remove('send');
        // container.classList.add('erro');
    }
};

if(btnAction.length){
    btnAction.forEach(function(btn){
        btn.addEventListener('click', function(e){
            e.preventDefault();

            let arquivoId = btn.getAttribute('data-id');
            let txtForm = btn.getAttribute('data-texto');

            inputArquivoId.value = arquivoId;
            textoForm.textContent = txtForm;

            LightboxContato.show();
        });
    });
}

if(btnClose != null){
    btnClose.addEventListener('click', function(e){
        e.preventDefault();
        LightboxContato.hide();
    });
}

if(btnSubmit != null){
    btnSubmit.addEventListener('click', function(){
        form.classList.add('validate');
    });
}

if(form != null) {
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        this.classList.add('send');

        let contactData = new FormData(this);

        contactData.append('optin_tel', document.getElementById('optin_tel').checked ? 1 : 0);
		contactData.append('optin_sms', document.getElementById('optin_sms').checked ? 1 : 0);
		contactData.append('optin_whatsapp', document.getElementById('optin_whatsapp').checked ? 1 : 0);
		contactData.append('optin_email', document.getElementById('optin_email').checked ? 1 : 0);

        setTimeout(function(){
            axios.post(`${BASE_PATH}/landing-page-lead`, contactData).then(function (response) {
                LightboxContato.success();

                btnDownloadArquivo.setAttribute('href', response.data.arquivo_url);

                setTimeout(function (){
                    window.location.href = response.data.arquivo_url;
                }, 2000);

            }).catch(function (err) {
                alert('Ocorreu um erro. Tente novamente mais tarde.')

                // console.log(err);
                LightboxContato.error();
            });
        }, 1000);
    });
}